import React from "react";
import { IMG_URl } from "src/common/img_url";
import { AlertDialogs } from "../Dialgos/Alter-Daylogs";
import { indexStore } from "src/store/indexStore";
import EditMenuModel from "../pages/menus/EditMenuModel";
import { useTranslation } from "react-i18next";
import { Skeleton } from "../ui/skeleton";
import Visibility from "../utils/Visibility";
import { userTypes } from "src/enums/usersTpes";
import { Card, CardContent, CardHeader } from "../ui/card";
import { Button } from "../ui/button";
import { Edit, Trash2, UtensilsCrossed, Image as ImageIcon } from "lucide-react";

export function MenuCard(props) {
  const { t } = useTranslation();
  const { deleteMenuAction, setMenu, nameLang } = indexStore();
  
  const onDeleteMenu = (id) => {
    deleteMenuAction(id);
  };
  
  const editCategory = (element) => {
    setMenu(element);
  };

  return (
    <Card className="group hover:shadow-xl transition-all duration-300 overflow-hidden border-2 hover:border-primary/20">
      <CardHeader className="p-0 relative">
        <div className="relative aspect-square w-full overflow-hidden bg-muted">
          {props.image ? (
            <img
              src={`${IMG_URl}/${props.image}`}
              alt={props[nameLang] || t("gloabl.menu")}
              className="object-cover w-full h-full group-hover:scale-110 transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-muted to-muted/50">
              <ImageIcon className="w-16 h-16 text-muted-foreground/30" />
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>
      </CardHeader>

      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-4">
          <div className="p-2 rounded-lg bg-primary/10">
            <UtensilsCrossed className="w-4 h-4 text-primary" />
          </div>
          <h3 className="text-lg font-bold text-foreground line-clamp-2 flex-1">
            {props[nameLang] || t("gloabl.menu")}
          </h3>
        </div>

        <Visibility
          visible={
            localStorage.getItem("role") === userTypes.ADMIN ||
            localStorage.getItem("role") === userTypes.DATAMANAGER
          }
        >
          <div className="flex gap-2 pt-4 border-t">
            <EditMenuModel
              trigger={
                <Button
                  variant="outline"
                  size="sm"
                  className="flex-1 gap-2"
                  onClick={() => editCategory(props)}
                >
                  <Edit className="w-4 h-4" />
                  {t("gloabl.edit")}
                </Button>
              }
            />
            <AlertDialogs
              trigger={
                <Button
                  variant="destructive"
                  size="sm"
                  className="gap-2"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              }
              variant="icon"
              onClickOk={() => onDeleteMenu(props.id)}
              description={<span>{t("gloabl.deleteMessage")}</span>}
              title={`${t("gloabl.delete")} ${t("gloabl.menu")}`}
            />
          </div>
        </Visibility>
      </CardContent>
    </Card>
  );
}

export const MenuCardLoading = () => (
  <Card className="overflow-hidden border-2">
    <CardHeader className="p-0">
      <Skeleton className="aspect-square w-full" />
    </CardHeader>
    <CardContent className="p-4">
      <div className="flex items-center gap-2 mb-4">
        <Skeleton className="w-8 h-8 rounded-lg" />
        <Skeleton className="h-5 flex-1" />
      </div>
      <div className="flex gap-2 pt-4 border-t">
        <Skeleton className="h-9 flex-1" />
        <Skeleton className="w-9 h-9" />
      </div>
    </CardContent>
  </Card>
);
